export interface MenuSelected {
    total: number;
    type: MENU_TYPE;
    labels: Labels;
}

interface Labels {
    singular: string;
    plural: string;
}

export enum MENU_TYPE {
    STANDARD = 'STANDARD',
    SPECIAL_MEALS = 'SPECIAL_MEALS'
}

export interface SpecialMealsLocalStorage {
    segments: Segment[];
    specialMealNumSelected: number;
}

interface Segment {
    id_segment: string;
    id_departure: string;
    desc_departure: string;
    id_arrival: string;
    desc_arrival: string;
    cabin: string;
    flightDate: string;
    flightNumber: string;
    company: string;
    specialMealAvailable: boolean;
    passengers: Passenger[];
    numSpecialMeals: number;
}
interface Passenger {
    id_passenger: string;
    name: string;
    surname: string;
    infant: boolean;
    menu?: string;
    menudesc?: string;
}

export interface ISpecialMealsSegment {
    status:            Status;
    id:                string;
    passengers:        string[];
    segmentPassengers: SegmentPassenger[];
    specialMeals:      SpecialMeal[];
    segmentInfo:       SegmentInfo;
}

export interface SegmentInfo {
    departure:           Arrival;
    arrival:             Arrival;
    departureDateParsed: DateParsed;
    arrivalDateParsed:   DateParsed;
    cabin:               Cabin;
}

export interface Arrival {
    code:     string;
    name:     string;
    terminal: string;
    city:     City;
}

export interface City {
    code:        string;
    description: string;
    countryCode: string;
    country:     Country;
}

export interface Country {
    code:        string;
    description: string;
}

export interface DateParsed {
    dateTime:     string;
    weekDay:      string;
    day:          number;
    monthNumber:  number;
    month:        string;
    year:         number;
    originalDate: Date;
    formatedDate: string;
}

export interface Cabin {
    rbd:            string;
    description:    string;
    remainingSeats: number;
    fareFamily:     null;
    code:           string;
    type:           string;
    bookingClass:   string;
}

export interface SegmentPassenger {
    passengerId: string;
    priceFrom:   number;
}

export interface SpecialMeal {
    code:        string;
    name:        string;
    description: string;
}

export interface Status {
    code:   string;
    reason: null | string;
}
